import {
  DEPOSIT_LIST,
  DEPOSIT_LIST_SUCCESS,
  DEPOSIT_LIST_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  deposit: [],
};

const depositListReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEPOSIT_LIST:
      return { ...state, loading: true };
    case DEPOSIT_LIST_SUCCESS:
      return {
        ...state,
        deposit: action?.payload,
        loading: false,
      };
    case DEPOSIT_LIST_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default depositListReducer;
